import Tastings from './Tastings'
export default Tastings
